export const locale = {
  lang: 'en',
  data: {
    'LABEL': 'No data',
  }
};
